import * as React from 'react';
// import { Link } from 'react-router-dom';
import { Col, Collapse, Row } from 'reactstrap';
import { IProject, IProposition, IStep } from 'src/model';
import { Svg } from '../shared/Svg';
import { PropositionCard } from './PaymentPropositionCard';

interface IPropositionListProps {
  label: string;
  propositionList: IProposition[];
  src: string;
  propositionFilter: (proposition: IProposition) => boolean;
}

const calculatePercentage = (
  project: IProject,
  proposition: IProposition
): number => {
  if (project.meta.status === 'ended') {
    return 100;
  } else if (project.meta.status === 'started') {
    if (proposition) {
      const stepListLength = proposition.stepList.length;
      if (stepListLength) {
        const endedStepNumber = proposition.stepList.filter(
          (step: IStep) => step.meta.status === 'validated'
        ).length;
        return Math.round((100 * endedStepNumber) / stepListLength);
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  } else {
    return 0;
  }
};


export const PropositionList: React.SFC<IPropositionListProps> = ({
  label,
  propositionFilter,
  propositionList,
  src,
}) => {
  const [collapse, toggleCollapse] = React.useState({
    isOpen: true,
  });

  return (
    <>
      <Row className='d-flex justify-content-between border-bottom mb-4'>
        <Col xs='10'>
          <h5 className='text-uppercase text-dark'>
            <Svg width={32} fill='dark' src={src} className='mr-2' />
            {label}
          </h5>
        </Col>
        <Col xs='2'>
          <Svg
            className='float-right'
            width={32}
            fill='dark'
            src='down'
            style={{
              transform: collapse.isOpen ? 'rotate(-180deg)' : 'rotate(0deg)',
            }}
            onClick={() => toggleCollapse({ isOpen: !collapse.isOpen })}
          />
        </Col>
      </Row>
      <Collapse isOpen={collapse.isOpen}>
        <Row className='d-flex align-items-center'>
          {propositionList.filter(propositionFilter).map(
            (proposition: IProposition, key: number) =>
              proposition && (
                <Col key={key} md='12' xs='auto'>
                  {/* <Link
                    to={entryPage(proposition)}
                    style={{ fontFamily: 'Slabo 27px' }}
                  > */}
                    <PropositionCard
                      project={proposition.project}
                      proposition={proposition}
                      calculatePercentage={calculatePercentage}
                    />
                  {/* </Link> */}
                </Col>
              )
          )}
        </Row>
      </Collapse>
    </>
  );
};



// WEBPACK FOOTER //
// ./src/components/Payment/PaymentPropositiontList.tsx